import {
  getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { PostApiV1ThreeLetterCodeClientAdminsStressAssessments201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * ストレスチェック作成APIを実行するカスタムフック。
 *
 * @param threeLetterCode - クライアントコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePostStressAssessments = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodeClientAdminsStressAssessments201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) =>
  useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsStressAssessmentsMutationFetcher(threeLetterCode),
    options
  );
